<span title="{{ tooltipDisplayValue() }}"
  >{{ textDisplayValue() }} <ng-content></ng-content
></span>
